import React, { useMemo, useState } from 'react';

import cn from 'classnames';

import { UiButton } from '@shared/ui';

import cls from './UiDropdownSearchList.module.css';
import { Icon } from '../Icon';
import { Input } from '../Input';
import { UiText } from '../UiText';

export interface UiDropdownSearchListItem {
    id: number;
    title: string;
}

interface UiDropdownSearchListProps {
    title: string;
    items: UiDropdownSearchListItem[];
    onClose: () => void;
    onItemClick?: (item: UiDropdownSearchListItem) => void;
    emptyText?: string;
    className?: string;
    hideCloseButton?: boolean;
}

export const UiDropdownSearchList = ({
    title,
    items,
    onClose,
    onItemClick,
    emptyText,
    className,
    hideCloseButton = false,
}: UiDropdownSearchListProps) => {
    const [searchValue, setSearchValue] = useState('');

    const filteredItems = useMemo(() => {
        const trimmedSearchValue = searchValue.trim().toLowerCase();

        if (!trimmedSearchValue) {
            return items;
        }

        return items.filter((item) => item.title.toLowerCase().includes(trimmedSearchValue));
    }, [searchValue, items]);

    return (
        <div className={cn(cls.UiDropdownSearchList, className)}>
            <div className={cls.header}>
                <UiText tag="h3" variant="subPlain" weight="medium">
                    {title}
                </UiText>
                {!hideCloseButton && (
                    <UiButton
                        className={cls.closeButton}
                        onClick={onClose}
                        variant="icon"
                        startIcon={<Icon iconName="closeModal" width={14} height={14} />}
                    />
                )}
            </div>
            <Input
                autoFocus
                value={searchValue}
                onChange={(event) => setSearchValue(event.target.value)}
                inputClassName={cls.searchInput}
            />
            <div className={cls.list}>
                {filteredItems.map((item) => (
                    <button
                        key={item.id}
                        type="button"
                        className={cls.item}
                        onClick={() => onItemClick?.(item)}
                    >
                        {item.title}
                    </button>
                ))}
                {!filteredItems.length && emptyText && (
                    <UiText className={cls.emptyText} variant="subPlain">
                        {emptyText}
                    </UiText>
                )}
            </div>
        </div>
    );
};
